var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "app-header navbar"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: ''
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "static/img/logo.png"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_vm._l((_vm.navItem), function(RowEle) {
    return _c('ul', {
      key: RowEle.name,
      staticClass: "nav navbar-nav",
      on: {
        "click": function($event) {
          _vm.navigateTo(("" + (RowEle.url)))
        }
      }
    }, [_c('li', [_c('router-link', {
      attrs: {
        "to": RowEle.url
      }
    }, [_c('i', {
      staticClass: "fa fa-clipboard-list",
      staticStyle: {
        "color": "#424242"
      }
    }), _vm._v("\n          " + _vm._s(RowEle.name) + "\n        ")])], 1)])
  }), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": _vm.analytics_dashboard_url,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('i', {
    staticClass: "fa fa-chart-line",
    staticStyle: {
      "color": "#424242"
    }
  }), _vm._v("\n          Analytics\n        ")])])]), _vm._v(" "), (_vm.showUccpDashboard) ? _c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": _vm.uccp_dashboard_url
    },
    on: {
      "click": _vm.syncSessionCookiesForUccp
    }
  }, [_c('i', {
    staticClass: "fa fa-tachometer-alt",
    staticStyle: {
      "color": "#424242"
    }
  }), _vm._v("\n          UCCP Dashboard\n        ")])])]) : _vm._e()], 2), _vm._v(" "), (!_vm.hideDepartment) ? _c('b-nav', {
    staticClass: "ml-auto",
    staticStyle: {
      "float": "right"
    }
  }, [_c('b-nav-item-dropdown', {
    staticClass: "lgout_main",
    staticStyle: {
      "bottom": "10px",
      "font-size": "15px"
    },
    attrs: {
      "right": ""
    }
  }, [_c('template', {
    slot: "button-content"
  }, [_c('img', {
    staticClass: "img-avatar",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "src": "static/img/avatars/default-img.png",
      "alt": "admin@bootstrapmaster.com"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "d-md-down-none"
  }, [_vm._v(_vm._s(_vm.username))])]), _vm._v(" "), _c('b-dropdown-item', {
    staticClass: "lgout",
    on: {
      "click": _vm.logout
    }
  }, [_c('i', {
    staticClass: "fa fa-lock"
  }), _vm._v(" Logout\n      ")])], 2)], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.hideDepartment && this.DepartmentName != '') ? _c('div', {
    staticStyle: {
      "position": "absolute",
      "right": "11px",
      "top": "28px",
      "font-size": "14px"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.DepartmentName) + "\n    "), _c('i', {
    staticClass: "fa fa-pencil",
    staticStyle: {
      "color": "#87ceeb",
      "cursor": "pointer"
    },
    attrs: {
      "title": "Change department"
    },
    on: {
      "click": function($event) {
        _vm.subDepartmentModalOpen()
      }
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.hideDepartment && this.DepartmentName == '') ? _c('div', {
    staticStyle: {
      "position": "absolute",
      "right": "11px",
      "top": "28px",
      "font-size": "14px",
      "color": "red"
    }
  }, [_vm._v("Department not available")]) : _vm._e(), _vm._v(" "), _c('b-modal', {
    attrs: {
      "no-close-on-esc": true,
      "no-close-on-backdrop": true
    },
    on: {
      "close": function($event) {
        _vm.subDepartmentModal = false
      }
    },
    model: {
      value: (_vm.subDepartmentModal),
      callback: function($$v) {
        _vm.subDepartmentModal = $$v
      },
      expression: "subDepartmentModal"
    }
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('b-card', {
    staticStyle: {
      "background-color": "transparent",
      "border": "0px solid transparent"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('h5', {
    staticClass: "modal-title",
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v("Department")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "type": "button",
      "aria-label": "Close",
      "title": "Close"
    },
    on: {
      "click": function($event) {
        _vm.subDepartmentModalClose()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    staticClass: "col-md-5"
  }, [_vm._v("Department Name:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sebDepartment),
      expression: "sebDepartment"
    }],
    staticClass: "select col-md-6",
    staticStyle: {
      "cursor": "pointer",
      "height": "38px",
      "background-color": "rgb(255, 251, 251)",
      "border-color": "#7ca2e8",
      "text-align-last": "center"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.sebDepartment = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("---Select department---")]), _vm._v(" "), _vm._l((_vm.DepartmentOptionObj), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option
      }
    }, [_vm._v(_vm._s(option.text))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('input', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "button",
      "value": "Change Department"
    },
    on: {
      "click": function($event) {
        _vm.changeDepartment()
      }
    }
  })])])])])], 1)])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0be33b65","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 580
// module chunks = 1